import schedule from "./schedule/schedule-loader";

schedule();
